
import { robinMediaArray } from './robinMedia'
import { tedReviewerProfile, barneyReviewerProfile } from './robinReviewers'
import { barneyBio, tedBio, robinBio } from './robinBios'
import { robinDatingProfileHinge, robinDatingProfileBumble, robinDatingProfileTinder } from './robinDatingProfiles'

export const robinSUser = {
  _id: 'robinUserId',
  email: 'robin@email.com',
  acceptedTOS: true,
  subscriptionIsActive: true,
  isReviewer: false,
  reviewerProfilesToSelectFrom: [
    { ...tedReviewerProfile },
    { ...barneyReviewerProfile }
  ],
  media: [ ...robinMediaArray ],
  bio: { ...robinBio },
  datingProfiles: [
    { ...robinDatingProfileHinge },
    { ...robinDatingProfileBumble },
    { ...robinDatingProfileTinder }
  ],
  reviewerProfile: {},
}

export const tedUser = {
  _id: 'tedUserId',
  email: 'ted@email.com',
  acceptedTOS: true,
  subscriptionIsActive: true,
  isReviewer: true,
  reviewerProfilesToSelectFrom: [],
  media: [],
  bio: { ...tedBio },
  datingProfiles: [],
  reviewerProfile: { ...tedReviewerProfile },
}

export const barneyUser = {
  _id: 'barneyUserId',
  email: 'barney@email.com',
  acceptedTOS: true,
  subscriptionIsActive: true,
  isReviewer: true,
  reviewerProfilesToSelectFrom: [],
  media: [],
  bio: { ...barneyBio },
  datingProfiles: [],
  reviewerProfile: { ...barneyReviewerProfile },
}
